import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

import AssessmentDetails from "Assessments/components/AssessmentDetails";

export default store => ({
  path: "tasks",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "leLibrary" */ "./components"),
        import(/* webpackChunkName: "leLibrary" */ "./modules/LELibraryModule"),
        import(
          /* webpackChunkName: "leLibrary" */ "AppComponents/LEIntoUnitImport/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const leLibraryReducer = importedModule1.default;
        injectReducer(store, {
          key: "leLibrary",
          reducer: leLibraryReducer,
        });

        const LEIntoUnitImportModule = importedModule2;
        injectReducer(store, {
          key: LEIntoUnitImportModule.NAME,
          reducer: LEIntoUnitImportModule.default,
        });

        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentDetails(store)],
});
